import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as AvatarPrimitive from '@radix-ui/react-avatar';
import { cn } from '../lib/cn.js';
export function initialsFromName(name, max = 2) {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0)
        return '';
    return parts
        .slice(0, max)
        .map((p) => p[0].toUpperCase())
        .join('');
}
const AvatarRoot = React.forwardRef(({ className, ...props }, ref) => (_jsx(AvatarPrimitive.Root, { ref: ref, className: cn('relative flex h-10 w-10 shrink-0 overflow-hidden rounded-[var(--radius-4)] bg-[var(--color-surface-sunken)]', className), ...props })));
AvatarRoot.displayName = 'Avatar';
const AvatarImage = React.forwardRef(({ className, ...props }, ref) => (_jsx(AvatarPrimitive.Image, { ref: ref, className: cn('aspect-square h-full w-full object-cover', className), ...props })));
AvatarImage.displayName = 'Avatar.Image';
const AvatarFallback = React.forwardRef(({ className, ...props }, ref) => (_jsx(AvatarPrimitive.Fallback, { ref: ref, className: cn('flex h-full w-full items-center justify-center text-xs font-medium text-[var(--color-text-secondary)]', className), ...props })));
AvatarFallback.displayName = 'Avatar.Fallback';
export const Avatar = Object.assign(AvatarRoot, {
    Image: AvatarImage,
    Fallback: AvatarFallback,
});
//# sourceMappingURL=avatar.js.map